// extracted by mini-css-extract-plugin
export default {"button":"PollMetaAnswers_button__KJ0Q4","answersAlert":"PollMetaAnswers_answersAlert__mOMHU"};